// extracted by mini-css-extract-plugin
module.exports = {"OrderCompletionPage":"OrderCompletionPage_OrderCompletionPage__3g_02"};